import _ from 'lodash';
import React, { useEffect } from 'react';
import { Grid, Form, Button, Message, Segment } from 'semantic-ui-react';

import Loading from '../../components/Loading';
import GeneralHelper from '../../helpers/general';

const LoginPage = (props) => {
	useEffect(() => {
		const query = GeneralHelper.queryStringToObject(props.location.search);

		props.showLoginForm({
			path: _.get(query, 'path')
		});

		// Cleanup method
		return () => props.resetPage();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onFieldChange = (e, data) => {
		props.onFieldChange(e.target.name, data.value);
	};

	const onKeyPress = e => {
		if (e.key === 'Enter') {
			onSubmit();
		}
	};

	const onSubmit = e => {
		const { email, password } = props.loginPageProps;
		const query = GeneralHelper.queryStringToObject(props.location.search);
		props.login({ email, password, query });
	};

	const { loginPageProps } = props;
	const { email, password, loading, error } = loginPageProps;

	if (!loginPageProps.showLoginForm) {
		return (
			<Grid>
				<Grid.Row>
					<Grid.Column width={16}>
						<Loading />
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}

	return (
		<Grid
			centered
			stackable
			className="with-padding"
			columns={2}
		>
			<Grid.Row>
				<Grid.Column>
					<Segment style={{padding: 25}}>
						<Form
							error={error !== ''}
							onSubmit={onSubmit}
						>
							<Form.Group widths="equal">
								<Form.Input
									name="email"
									type="email"
									label="Email address"
									value={email}
									onChange={onFieldChange}
									onKeyPress={onKeyPress}
									required
								/>
							</Form.Group>
							<Form.Group widths="equal">
								<Form.Input
									name="password"
									type="password"
									label="Password"
									value={password}
									onChange={onFieldChange}
									onKeyPress={onKeyPress}
									required
								/>
							</Form.Group>
							<Button
								content="Login"
								primary
								fluid
								loading={loading}
								disabled={loading}
								style={{marginTop: 35, marginBottom: 40, backgroundColor: '#075185'}}
							/>
							{error && (
								<Message
									error
									content={error}
								/>
							)}
						</Form>
					</Segment>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default LoginPage;
